@if (!isLoading && isDisabled) {
  <span id="wallet-attr-tab-msg-disabled" class="disabled-tab-message" i18n>
  * Para cambiar la configuración de atributos, debe incluir al menos una dirección de correo
  electrónico.
</span>
}

<span id="wallet-attr-tab-span-desc" class="tab-description" i18n
  >Me gustaría recibir notificación de los siguientes cambios:</span
  >

  @if (!isLoading) {
    <div id="wallet-attr-tab-content" class="content-container">
      @for (group of groupsWithSubgroups; track group; let iGroup = $index) {
        <div class="type-attributes-container" id="wallet-attr-tab-container-group-{{iGroup}}">
          <span class="attribute-type" id="wallet-attr-tab-span-group-{{iGroup}}">{{ group.name }}</span>
          <div class="attributes-container" id="wallet-attr-tab-container-attrs-{{iGroup}}">
            @for (subgroup of group.subgroups; track subgroup; let iSub = $index) {
              <div
                class="attribute-info"
                [ngClass]="{ 'attribute-info__disabled': isDisabled }"
                id="wallet-attr-tab-attr-info-{{group.id}}-{{iSub}}"
                >
                <input
                  type="checkbox"
                  id="wallet-attr-tab-checkbox-{{ group.id }}-{{ iSub }}"
                  name="wallet-attr-tab-checkbox-{{ group.id }}-{{ iSub }}"
                  [checked]="subgroup.active"
                  (change)="onToggleSubgroupStatus($any($event.target).checked, subgroup)"
                  [disabled]="isDisabled"
                  />
                  <label for="wallet-attr-tab-checkbox-{{ group.id }}-{{ iSub }}" id="wallet-attr-tab-label-{{ group.id }}-{{ iSub }}">
                    {{ subgroup.name }}
                  </label>
                </div>
              }
            </div>
          </div>
        }
      </div>
    }

    @if (isLoading) {
      <div id="wallet-attr-tab-loading" class="loading-spinner">
        <app-ellipsis-loading id="wallet-attr-tab-ellipsis-loading"></app-ellipsis-loading>
        <span i18n="@@loadingInformation" id="wallet-attr-tab-span-loading">Cargando información</span>
      </div>
    }

    @if (!isLoading && !groupsWithSubgroups.length) {
      <div id="wallet-attr-tab-nodata" class="no-data-container">
        <span i18n="@@noAttributesForWalletPlan" id="wallet-attr-tab-span-nodata">
    El plan de esta cartera no tiene atributos disponibles para enviar alertas.
  </span>
      </div>
    }
